<template>
  <div style="width: 99%">
    <el-row :gutter="15">
      <el-col :span="15">
        <el-input placeholder="请输入文章标题" v-model="blog.title"></el-input>
      </el-col>
      <el-col :sm="4" :xs="12" style="display: flex">
        <el-button style="border-radius: 20px" type="danger" @click="openEdit">发布文章</el-button>
        <el-button style="border-radius: 20px" type="success" @click="openImageUpload">上传图片</el-button>
      </el-col>
    </el-row>
    <el-row>
      <mavon-editor
        ref="md"
        @save="saveMd"
        style="margin: 10px auto;min-height: 70vh"/>
    </el-row>

    <el-dialog :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false" title="发布文章"
               width="500px" :visible.sync="dialogFormVisible">
      <el-form :model="blog" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item label="文章分类：" :label-width="formLabelWidth" prop="categoryId">
          <el-select style="width: 140px" size="small" v-model="blog.categoryId" placeholder="请选择">
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章介绍：" :label-width="formLabelWidth" prop="introduction">
          <el-input type="textarea" v-model="blog.introduction" placeholder="请输入介绍" size="small"
                    style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="文章首图：" :label-width="formLabelWidth" prop="firstImage">
          <el-upload
            class="avatar-uploader"
            :action='base_url_uploadImage'
            name="image"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="blog.firstImage" :src="blog.firstImage" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-popover
          placement="top"
          width="160"
          title="最后一次提示"
          v-model="form.visible">
          <p>是否保存了文章(ctrl+s)？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="small" @click="goSave">去保存</el-button>
            <el-button size="small" type="success" @click="submit('ruleForm')">发表</el-button>
          </div>
          <el-button size="small" type="primary" slot="reference">发布文章</el-button>
        </el-popover>
      </div>
    </el-dialog>

    <el-dialog :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false" title="上传图片"
               width="500px" :visible.sync="uploadStaticImageVisible">
      <el-upload
        class="upload-demo"
        :action="uploadStaticImage"
        :on-preview="beforeAvatarUpload"
        :on-success="uploadStaticImageSuccess"
        name="image"
        list-type="picture">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2000kb</div>
      </el-upload>
      <span>图片地址:{{ uploadStaticImagePath }}</span>
    </el-dialog>

  </div>

</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  data() {
    var validateCategory = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('分类不能为空'));
      } else {
        callback()
      }
    };
    var validateIntroduction = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('介绍不能为空'));
      } else {
        callback()
      }
    };
    var validateFirstImage = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('图片不能为空'));
      } else {
        callback()
      }
    };
    return {
      //静态图片位置
      uploadStaticImage: base_url + '/uploadStaticImage',
      base_url: base_url,
      uploadStaticImageVisible: false,
      uploadStaticImagePath: null,
      base_url_uploadImage: base_url + '/uploadImage',
      blog: {
        adminId: '',
        title: "",
        introduction: '',
        firstImage: '',
        contentHtml: "",
        contentText: '',
        categoryId: '',
      },
      categories: [
        {
          id: null,
          name: null
        },
      ],
      formLabelWidth: '100px',
      dialogFormVisible: false,
      form: {
        visible: false
      },
      rules: {
        categoryId: [
          {required: true, validator: validateCategory, trigger: 'blur'}
        ],
        introduction: [
          {required: true, validator: validateIntroduction, trigger: 'blur'}
        ],
        firstImage: [
          {required: true, validator: validateFirstImage, trigger: 'blur'}
        ]
      },
      adminInfo: {}
    }
  },
  methods: {
    //上传图片
    openImageUpload() {
      this.uploadStaticImageVisible = true
    },
    saveMd(value, render) {
      this.$notify({
        type: 'success',
        title: '博客',
        duration: 2000,
        message: '保存成功'
      })
      this.blog.contentHtml = render;
      this.blog.contentText = this.$refs.md.d_value
      // console.log(this.$refs.md.d_value);
    },
    //打开发布博客最后一步
    openEdit() {
      this.dialogFormVisible = true;
    },
    //去保存
    goSave() {
      this.form.visible = false;
      this.dialogFormVisible = false;
    },
    //提交文章内容
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.visible = false;
          if (this.blog.title !== '') {
            request({
              url: '/blog/input',
              method: 'post',
              data: {
                articleJson: JSON.stringify(this.blog),
              },
              params: {
                adminInfo: this.adminInfo
              }
            }).then(response => {
              if (response.data.flag) {
                this.$notify({
                  title: "文章",
                  type: "success",
                  duration: 2000,
                  message: '提交成功'
                })
                this.dialogFormVisible = false;
              } else {
                this.$notify({
                  title: "文章",
                  type: "error",
                  duration: 2000,
                  message: '提交失败'
                })
              }
            }).catch(e => {
              this.$notify({
                title: "文章",
                type: "error",
                duration: 2000,
                message: '网络错误'
              })
            })
          } else {
            this.dialogFormVisible = false;
            this.$notify.error({
              title: '标题',
              message: '没有文章标题'
            })
          }
        } else {
          return false;
        }
      });
      this.form.visible = false;
    },
    //处理头像成功
    handleAvatarSuccess(result) {
      let data = result.data;
      this.blog.firstImage = data;
    },
    //上传静态图片成功
    uploadStaticImageSuccess(result) {
      this.uploadStaticImagePath = "<img src='" + result.data + "' width='100' height='100'>";
    },
    //上传头像前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },
    //获取分类
    getCategory() {
      request({
        url: '/blog/getCategories',
        method: 'get',
      }).then(response => {
        // console.log(response)
        this.categories = response.data.data;
      })
    },

  },
  mounted() {
    this.getCategory();
    let adminInfo = JSON.parse(window.sessionStorage.getItem("adminInfo"));
    this.blog.adminId = adminInfo.id;
    this.adminInfo = adminInfo;
  }
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/BlogInput.vue